// React
import React from 'react';
// External
import { Form } from 'react-bootstrap';
import SelectSearch from 'react-select-search';
import { Link } from 'react-router-dom';
import { FcCheckmark } from 'react-icons/fc';
// Internal
import NavbarPrimary from 'components/shared/organisms/NavbarPrimary/NavbarPrimary';
import NavbarSecondary from 'components/shared/organisms/NavbarSecondary/NavbarSecondary';
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';
import CustomTable from 'components/shared/molecules/CustomTable/CustomTable';
import { getTeamMembers } from 'services/managePractice';
import VetService from 'services/vet';
import newMember from 'models/Member';
import PRICING_OPTIONS from 'constants/pricingOptions';
// Styles
import './styles.scss';

class ManagePractice extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pricingSelected: '',
            teamList: [],
            showCheckIcon: false
        };

        this.getVetDetails();
        this.getTeamMemberList();
        this.headers = Object.freeze([
            {
                name: 'First name',
                id: 'firstName',
            },
            {
                name: 'Last name',
                id: 'lastName',
            },
            {
                name: 'Email',
                id: 'email',
            },
            {
                name: 'Role',
                id: 'accessLevel',
            },
            {
                name: 'Action',
                id: 'action',
            },
        ]);

        this.selectSearchRefs = React.createRef();
        this.bOpenOptions = false;
        this.bEnterPressed = false;
    }

    /**
     * Get Vet Detail to display the price book
     */
    getVetDetails() {
        VetService.getVetDetails()
            .then((response) => {
                this.setState({ pricingSelected: response.data.cstm.pricing_information_c });
            }).catch((err) => {
                console.error(err);
            });
    }

    /**
     * Retrieves the team member list from sugar API
     */
    getTeamMemberList() {
        getTeamMembers()
            .then((response) => {
                const teamList = response.data.map((member) => {
                    return {
                        ...newMember(member).customTableFormat(),
                        action: <Link to={`/manage-practice/view-member/${member.id}`}>Edit</Link>
                    };
                });
                this.setState({ teamList });
            }).catch(() => {
                /**
                 * @todo Handle error
                 */
            });
    }

    /**
     * Get Vet Detail to display the price book
     */
    updatePriceBook(value) {
        VetService.updateVetDetails({ pricing_information_c: value })
            .then((response) => {
                this.setState({
                    pricingSelected: response.data.cstm.pricing_information_c,
                    showCheckIcon: true
                });
                setTimeout(() => {
                    this.setState({ showCheckIcon: false });
                }, 2500);
            }).catch((err) => {
                console.error(err);
            });
    }

    render() {
        return (
            <div className="main-container">
                <NavbarSecondary />
                <NavbarPrimary />
                <div className="body-content">
                    <PageTitle title="Manage practice" />
                    <ContentCard
                        className="mt-62"
                        headerTitle="Product pricing display"
                        headerSubComponent={(
                            <p className="practice-sub-header">
                                Choose how you’d like pricing to appear when products are displayed.
                                Choose between recommended retail price or no price displayed.
                            </p>
                        )}
                        divider
                    >
                        <div className="pricing-body">
                            <Form.Row>
                                <Form.Group controlId="pricingSelected" className="control-group">
                                    <Form.Label>PRICING OPTIONS</Form.Label>
                                    <SelectSearch
                                        ref={this.selectSearchRefs}
                                        options={PRICING_OPTIONS}
                                        onChange={(value) => { 
                                            this.updatePriceBook(value); 

                                            // If the enter key is pressed, set it back to false and then focus back to the dropdown
                                            if (this.bEnterPressed) {
                                                this.bEnterPressed = false;
                                                setTimeout(() => this.selectSearchRefs.current.querySelector('input').focus(), 50);
                                            }
                                        }}
                                        renderValue={(valueProps) => (
                                            <Form.Control
                                                {...valueProps}
                                                name="pricingSelected"
                                                type="text"
                                                value={this.state.pricingSelected}
                                                onMouseDownCapture={objEvent => {
                                                    this.bOpenOptions = true;
                                                }}
                                                onFocusCapture={objEvent => {
                                                    if (!this.bOpenOptions) {
                                                        objEvent.stopPropagation();
                                                    } else {
                                                        this.bOpenOptions = false;
                                                    }
                                                }}
                                                onKeyDownCapture={objEvent => {
                                                    if (objEvent.key === 'Tab') {
                                                        try {
                                                            // Get the currently highlighted option and use it as the selected value
                                                            const value = objEvent.target.parentElement.parentElement.querySelector('.is-highlighted').value;
                                                            
                                                            this.updatePriceBook(value)
                                                        } catch(objError) {
                                                            console.log('Error in selecting pricing options: ', objError);
                                                        }
                                                    }

                                                    // If the enter key is pressed, set the flag to true and then set the open options flag to false
                                                    if (objEvent.key === 'Enter') {
                                                        this.bOpenOptions = false;
                                                        this.bEnterPressed = true;
                                                    }

                                                    // If the arrow up or down is pressed, open the options
                                                    if (objEvent.key === 'ArrowUp' || objEvent.key === 'ArrowDown') {
                                                        this.selectSearchRefs.current.querySelector('input').blur();

                                                        this.bOpenOptions = true;            

                                                        this.selectSearchRefs.current.querySelector('input').focus();
                                                    }
                                                }}
                                            />
                                        )}
                                    />
                                    {
                                        this.state.showCheckIcon
                                            ? (
                                                <FcCheckmark
                                                    className={
                                                        this.state.showCheckIcon
                                                            ? 'check-icon check-icon-animation'
                                                            : 'check-icon'
                                                    }
                                                />
                                            ) : null
                                    }
                                </Form.Group>
                            </Form.Row>
                        </div>
                    </ContentCard>

                    <ContentCard
                        className="mt-40 practice-header"
                        headerTitle="Manage team"
                        headerBtnText="New staff member"
                        headerSubComponent={(
                            <p className="practice-sub-header">
                                View and update team member profiles, listed below.
                            </p>
                        )}
                        to="manage-practice/new-member"
                        divider={false}
                    >
                        <CustomTable
                            data={this.state.teamList}
                            headers={this.headers}
                            className="dashboard-table"
                        />
                    </ContentCard>
                </div>
            </div>
        );
    }
}

export default ManagePractice;
